import { render, staticRenderFns } from "./OrderContainer.vue?vue&type=template&id=402fb191&"
import script from "./OrderContainer.vue?vue&type=script&lang=js&"
export * from "./OrderContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports